const $ = require('jquery')
const Vue = require('vue')
const Promise = require('bluebird')

Vue.directive('tooltip', {
    twoWay: true,

    priority: 1000,

    params: ['title', 'vtitle', 'position'],

    paramWatchers: {
        title (newVal) {
            $(this.el)
                .attr('data-original-title', newVal)
                .tooltip('fixTitle')
        }
    },

    bind: function () {
        const params = {
            placement: this.params.position || 'top',
            container: 'body',
            html: true
        }

        if (this.params.vtitle || this.params.title) {
            params.title = this.params.vtitle || this.params.title
        }

        $(this.el).tooltip(params)
        $(this.el).click(() => {
            $(this.el).tooltip('hide')
        })
    },
    update: function () {
        let title = null

        if (this.params.vtitle || this.params.title) {
            title = this.params.vtitle || this.params.title
        }

        $(this.el)
            .attr('data-original-title', title)
            .tooltip('fixTitle')
    },
    unbind: function () {
        $(this.el).tooltip('destroy')
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/tooltip.js